import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

/**
 * One filter on a list screen — GEN-61.
 *
 * Extracted for the reason `Pager` was, at three times the size: `Library` had two of
 * these and `Lessons` wanted five more, all the same sixteen lines varying in a label and
 * where the options come from. Seven copies is seven places an a11y or styling fix has to
 * land, and they had already started to differ.
 *
 * "Any" is part of the control rather than each caller's first child, because an empty
 * value is what every one of these means by *not filtering*, and a screen that spelled it
 * differently would send `""` to the server as a filter.
 */
export interface Option {
  value: string;
  label: string;
}

/** An enum's own values, which read the same as they filter. */
export const sameAs = (values: readonly string[]): Option[] =>
  values.map((value) => ({ value, label: value }));

export function FilterSelect({
  label,
  value,
  options,
  width,
  onChange,
}: {
  label: string;
  value: string;
  options: readonly Option[];
  width: number;
  onChange: (value: string) => void;
}) {
  return (
    <TextField
      select
      size="small"
      label={label}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      sx={{ minWidth: width }}
    >
      <MenuItem value="">Any</MenuItem>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
